import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';

const Value = styled<any, any>('div')`
    ${propStyles};
`;

Value.defaultProps = {
    textDecoration: 'inherit',
};

interface ChangeIndicatorValueProps {
    changeTheme: string | number;
    color: string;
    theme?: { [property: string]: string | number };
    value: string | number;
}

const iconStyleProps = {
    display: 'inline-block',
    verticalAlign: 'middle',
};

@observer
class ChangeIndicatorValue extends Component<ChangeIndicatorValueProps> {
    render() {
        const { changeTheme, color, theme, value } = this.props;
        return (
            <Value
                color={color}
                {...changeTheme}
                {...theme.ChangeValue}
                {...iconStyleProps}
            >
                <Translate>{value}</Translate>
            </Value>
        );
    }
}

export default withTheme(ChangeIndicatorValue);



// WEBPACK FOOTER //
// ./src/Components/ChangeIndicatorValue.tsx